import React from "react";

import classes from "./DropdownItem.module.scss";

const DropdownItem = (props) => {
  let style = props.last
    ? {
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px"
      }
    : null;
  return (
    <div className={classes.wrapper} style={style} onClick={() => props.click(props.children)}>
      {props.children}
    </div>
  );
};

export default DropdownItem;
